import React, { Component } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Table from './components/Table';
import Form from './components/Form';
import Filters from './components/Filters';
import API from '../../services/API';
import Icon from "../../components/Icon";
import SyncMessage from "../../components/SyncMessage";

class AdkBoosters extends Component {
    constructor() {
        super();

        this.state = {
            feeds: [],
            boosters: [],
            isLoading: false,
            isShowForm: false,
            boosterToUpdate: null,
            syncData: null,
        };

        this.handleAddBtnClick = this.handleAddBtnClick.bind(this);
        this.handleUpdateBtnClick = this.handleUpdateBtnClick.bind(this);
        this.handleRemoveBtnClick = this.handleRemoveBtnClick.bind(this);
        this.handleFormHide = this.handleFormHide.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleSync = this.handleSync.bind(this);
        this.handleFiltersSubmit = this.handleFiltersSubmit.bind(this);
    }

    componentDidMount() {
        this.loadFeeds();
        this.loadBoosters();
    }

    loadFeeds() {
        API.AdkFeeds.getIds()
            .then(feeds => this.setState({ feeds }));
    }

    loadBoosters() {
        API.AdkBoosters.get()
            .then(({ boosters }) => this.setState({ boosters, isLoading: false }));
    }

    handleAddBtnClick() {
        this.setState({ isShowForm: true });
    }

    handleFormHide() {
        this.setState({ isShowForm: false, boosterToUpdate: null });
    }

    handleFormSubmit(booster) {
        this.setState({
            isShowForm: false,
            isLoading: true,
            boosterToUpdate: null
        });

        if(booster.subid) {
            booster.subid = booster.subid.split(',').map(subid => subid.trim());
        }

        if(booster.update) {
            const { id } = booster;
            delete booster.id;

            API.AdkBoosters.update(id, booster).then(() => this.loadBoosters());
        }
        else API.AdkBoosters.save(booster).then(() => this.loadBoosters());
    }

    handleUpdateBtnClick(booster) {
        this.setState({ isShowForm: true, boosterToUpdate: booster });
    }

    handleRemoveBtnClick(id) {
        this.setState({ isLoading: true });

        API.AdkBoosters.remove(id)
            .then(() => this.loadBoosters());
    }

    handleSync() {
        this.setState({ isLoading: true });

        API.Sync([ 'adk-EU', 'adk-US', 'adk-SG' ], 'boosters')
            .then((res) => {
                this.setState({ isLoading: false, syncData: { res } });

                setTimeout(() => this.setState({ syncData: null }), 10000);
            })
            .catch(err => {
                this.setState({ isLoading: false, syncData: { reqErr: err } });
                setTimeout(() => this.setState({ syncData: null }), 10000);
            });
    }

    handleFiltersSubmit(filters) {
        this.setState({ isLoading: true });

        API.AdkBoosters.get(filters)
            .then(({ boosters }) => this.setState({ boosters, isLoading: false }));
    }

    getForm() {
        if(this.state.isShowForm) {
            return <Form
                onSubmit={this.handleFormSubmit}
                onFormHide={this.handleFormHide}
                feeds={this.state.feeds}
                booster={this.state.boosterToUpdate}/>;
        }
    }

    render() {
        return (
            <Container loading={this.state.isLoading}>
                <Heading title="ADK Boosters"/>
                <Filters feeds={this.state.feeds} onSubmit={this.handleFiltersSubmit}/>
                <Row>
                    <Col lg={12}>
                        <div className="pull-right m-b-15">
                            <Button bsStyle="success" onClick={this.handleAddBtnClick}><Icon name="plus"/> Add</Button>
                            <Button bsStyle="info" onClick={this.handleSync}> Sync</Button>
                        </div>
                    </Col>
                </Row>
                <SyncMessage {...this.state.syncData} />
                {this.getForm()}

                <Table boosters={this.state.boosters} onRemove={this.handleRemoveBtnClick} onUpdate={this.handleUpdateBtnClick}/>
            </Container>
        );
    }
}

export default AdkBoosters;


// WEBPACK FOOTER //
// ./src/scenes/AdkBoosters/index.js